import React from 'react'
import { Form } from 'semantic-ui-react'
import {
    FormTextFormField,
    FormDropdownField,
    SubmitCancelButtons,
} from 'elements'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const AssetSearchSchema = yup.object().shape({
    SearchText: yup.string(),
    Location: yup.string(),
    Category: yup.string(),
    Status: yup.string(),
})

export const AssetSearchForm = ({
    filterChanged,
    loading,
    locationOptions,
    categoryOptions,
    statusOptions,
}) => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(AssetSearchSchema),
        defaultValues: {
            SearchText: '',
            Location: '',
            Category: '',
            Status: '',
        },
    })

    const submit = async formData => {
        filterChanged(formData)
    }

    const resetForm = () => {
        reset({ SearchText: '', Location: '', Category: '', Status: '' })
        filterChanged({ SearchText: '', Location: '', Category: '', Status: '' })
    }

    return (
        <Form noValidate>
            <div className="my-2">
                <Form.Group widths="equal">
                    <FormTextFormField
                        control={control}
                        label="Search"
                        name="SearchText"
                        placeholder="Search by name or ID"
                        errors={errors?.SearchText}
                        defaultValue=""
                    />
                    <FormDropdownField
                        control={control}
                        label="Location"
                        name="Location"
                        placeholder="Location"
                        errors={errors?.Location}
                        options={locationOptions}
                        defaultValue=""
                        search
                    />
                    <FormDropdownField
                        control={control}
                        label="Category"
                        name="Category"
                        placeholder="Category"
                        errors={errors?.Category}
                        options={categoryOptions}
                        defaultValue=""
                        search
                    />
                    <FormDropdownField
                        control={control}
                        label="Status"
                        name="Status"
                        placeholder="Status"
                        errors={errors?.Status}
                        options={statusOptions}
                        defaultValue=""
                        search
                    />
                </Form.Group>
            </div>
            <SubmitCancelButtons
                loading={loading}
                onSubmit={handleSubmit(submit)}
                onCancel={resetForm}
            />
        </Form>
    )
}
